import React from 'react'

const About = () => {
    return (

        <div className="bg-gray-200  p-8 shadow-sm">
            <div className="max-w-4xl mx-auto">
                <h1 className="text-3xl font-bold mb-4">About Us</h1>
                <p className="text-lg mb-4">
                    Welcome to our recipe website! We are passionate about sharing delicious recipes with food enthusiasts like you. Our goal is to inspire you to get creative in the kitchen and enjoy the process of cooking and baking.
                </p>
                <p className="text-lg mb-4">
                    Whether you're a seasoned chef or just starting out, our collection of recipes caters to all skill levels. From quick and easy meals to gourmet dishes, we have something for everyone.
                </p>
                <p className="text-lg mb-4">
                    We believe that good food brings people together, and we hope that our recipes help you create memorable moments with your loved ones. So, grab your apron and let's start cooking!
                </p>
            </div>
        </div>

    )
}

export default About
